import React from 'react';

import moreMenuStyles from './AlmeMoreMenu.styles';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import { WithStyles, withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import { MenuProps } from '@material-ui/core/Menu';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { FocusComponentProps } from '../../models/ComponentProps';
import { AlmeMoreMenuConfig } from './AlmeMoreMenuConfig';
import { AlmeIvaTypeProp } from '../../models/AlmeIvaTypeMapping';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            display: 'inline-block',
        },
    }),
);

const StyledMenu = withStyles(moreMenuStyles)((props: MenuProps) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
    },
}))(MenuItem);

interface AlmeMoreMenuProps extends WithStyles<typeof moreMenuStyles> {
    almeConfig: AlmeMoreMenuConfig;
    ivaType?: AlmeIvaTypeProp;
    focusProps?: FocusComponentProps;
}

const AlmeMoreMenu: React.FC<AlmeMoreMenuProps> = (props: AlmeMoreMenuProps) => {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (): void => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!props.almeConfig.moreMenu.isEmailTranscriptEnabled || props.ivaType === 'popup') {
        return null;
    }

    return (
        <div className={classes.root}>
            <IconButton
                title="More"
                aria-controls={id}
                aria-haspopup="true"
                onClick={handleClick}
                {...props.focusProps}
                size={props.almeConfig.moreMenu.styles.buttonSize || 'small'}
            >
                <MoreVertIcon />
            </IconButton>
            <StyledMenu
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <StyledMenuItem>Email Transcript</StyledMenuItem>
            </StyledMenu>
        </div>
    );
};

export default withStyles(moreMenuStyles)(AlmeMoreMenu);